import apiService from '@/services/apiService';

const actions = {
  getPrivacyPolicys({ commit }) {
    return new Promise((resolve, reject) => {
      apiService.get('privacy-policy')
        .then((response) => {
          commit('getPrivacyPolicys', response.data.data);
          resolve(response);
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
  },
  getPrivacyPolicy({ commit }, payload) {
    apiService.get(`privacy-policy/${payload}`)
      .then((response) => {
        commit('getPrivacyPolicy', response.data.data);
      })
      .catch((error) => {
        console.log(error);
      });
  },
  postPrivacyPolicy({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.post('privacy-policy', payload)
        .then((response) => {
          commit('postPrivacyPolicy', payload);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  putPrivacyPolicy({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.put(`privacy-policy/${payload.id}`, payload.formData)
        .then((response) => {
          commit('putPrivacyPolicy', payload);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  delPrivacyPolicy({ commit }, payload) {
    apiService.delete(`privacy-policy/${payload}`)
      .then((response) => {
        commit('delPrivacyPolicy', payload);
        console.log(response);
      })
      .catch((error) => {
        console.log(error);
      });
  },

};

export default actions;
